





































import * as Util from '@/util.ts';
import Vue from 'vue';
import { setTimeout } from 'timers';

export default Vue.extend({
  props: {
    label: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    price: {
      type: Number,
      default: 0,
    },
    quantity: {
      type: Number,
      required: true,
    },
    initiallyActive: {
      type: Boolean,
      default: false,
    },
    sideText: {
      type: String,
      default: '',
    },
    notYetVerified: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContent: false,
    };
  },
  computed: {
    oneTimeChargeString(): string {
      return Util.t?.oneTimeCharge.supplant([Util.formatCurrency(this.$props.price)]);
    },
  },
  mounted() {
    this.$data.content = this.$refs.content;
    Util.eventBus.$on('closeAccordions', this.onCloseAccordion);
    if (this.$props.initiallyActive) {
      this.$data.showContent = true;
    }
  },
  watch: {
    $route(to, from) {
      if (this.$props.initiallyActive) {
        this.$data.showContent = true;
      }
    },
  },
  methods: {
    onLabelClick() {
      if (this.$data.showContent) {
        this.onCloseAccordion();
      } else {
        Util.eventBus.$emit('closeAccordions');
        this.$data.showContent = true;
        Vue.nextTick(() => {
          (this.$refs.buttonBar as HTMLElement).scrollIntoView({
            block: 'start',
            behavior: 'smooth',
          });
        });
      }
    },
    onCloseAccordion() {
      this.$data.showContent = false;
    },
  },
});
